export function isPromiseRejectedResultArray(value: unknown): value is PromiseRejectedResult[] {
  if (!Array.isArray(value)) {
    return false
  }

  return value.every(
    (item) =>
      item !== null &&
      typeof item === 'object' &&
      'status' in item &&
      item.status === 'rejected' &&
      'reason' in item
  )
}
